import { useRef, useState } from "react";
import Notification from "./Notification";
import { Form, Button } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

const Contact = () => {
  const [formSent, setFormSent] = useState(false);

  const contactName = useRef();
  const contactEmail = useRef();
  const contactMessage = useRef();

  function hideError() {
    setTimeout(function () {
      setFormSent(false);
    }, 5000);
  }

  const formik = useFormik({
    initialValues: {
      inputName: "",
      inputEmail: "",
      inputMessage: "",
    },
    validationSchema: Yup.object({
      inputName: Yup.string()
        .min(3, "Must be 3 characters or more")
        .required("Required"),
      inputEmail: Yup.string()
        .email("Invalid email address")
        .required("Required"),
      inputMessage: Yup.string()
        .min(20, "Must be 20 characters or more")
        .required("Required"),
    }),
    onSubmit: (values) => {
      const inquiryName = values.inputName;
      const inquiryEmail = values.inputEmail;
      const inquiryMessage = values.inputMessage;

      contactName.current.value = "";
      contactEmail.current.value = "";
      contactMessage.current.value = "";

      values.inputName = "";
      values.inputEmail = "";
      values.inputMessage = "";

      setFormSent(true);
      hideError();
    },
  });

  // function onEmptyInput() {
  //   errorObject.isError = true;
  //   errorObject.errorMessage = "City can't be blank";
  //   setWeatherData({ ...weatherData, errorObject });
  //   hideError();
  // }

  // const clicked = (e) => {
  //   const inquiryName = contactName.current.value;
  //   const inquiryEmail = contactEmail.current.value;
  //   const inquiryMessage = contactMessage.current.value;

  //   // if (!inquiryName || !inquiryEmail || !inquiryMessage) {
  //   //   onEmptyInput();
  //   // } else {
  //   //   onSearch(city);
  //   //   contactName.current.value = "";
  //   //   contactEmail.current.value = "";
  //   //   contactMessage.current.value = "";
  //   // }

  //   contactName.current.value = "";
  //   contactEmail.current.value = "";
  //   contactMessage.current.value = "";
  //   setFormSent(true);
  //   hideError();
  // };

  return (
    <div className="container-fluid py-4 px-4 contact-section page-header bg-harsh vh-100">
      <div className="row touch-section pt-4">
        <div className="col-12 col-lg-4 my-5 d-flex flex-column align-items-center get-in-touch">
          <h2 className="text-orange-a">Get in Touch</h2>

          <div className="social-icons">
            <span className="social">
              <a
                className="fa-stack fa-lg"
                target="_blank"
                rel="noreferrer"
                href="https://twitter.com/crooz_lotus"
              >
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa fa-twitter fa-stack-1x fa-inverse"></i>
              </a>
              <a
                className="fa-stack fa-lg"
                target="_blank"
                rel="noreferrer"
                href="https://www.linkedin.com/in/croozlotus"
              >
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa fa-linkedin-square fa-stack-1x fa-inverse"></i>
              </a>
              <a
                className="fa-stack fa-lg"
                target="_blank"
                rel="noreferrer"
                href="https://github.com/DipoDre"
              >
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa fa-github fa-stack-1x fa-inverse"></i>
              </a>
              <a
                className="fa-stack fa-lg"
                target="_blank"
                rel="noreferrer"
                href="mailto:damidipo@gmail.com?cc=damidipo85@yahoo.com&bcc=dare.afolabi@teqmatta.com"
              >
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa fa-envelope-o fa-stack-1x fa-inverse"></i>
              </a>
              <a
                className="fa-stack fa-lg"
                target="_blank"
                rel="noreferrer"
                href="tel:+2348122259244"
              >
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa fa-phone fa-stack-1x fa-inverse"></i>
              </a>
            </span>
          </div>
        </div>

        <div className="col-12 col-lg-6 my-4 form-section">
          {formSent && <Notification data={"Your message has been sent."} />}

          <Form onSubmit={formik.handleSubmit} className="contact-form">
            <Form.Group>
              <Form.Control
                ref={contactName}
                type="text"
                id="inputName"
                name="inputName"
                placeholder="Enter Your Name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.inputName}
              />
              {formik.touched.inputName && formik.errors.inputName ? (
                <div className="form-error">{formik.errors.inputName}</div>
              ) : null}

              <Form.Control
                ref={contactEmail}
                type="email"
                id="inputEmail"
                name="inputEmail"
                placeholder="Enter Your Email { YourEmail@email.com }"
                aria-describedby="emailHelp"
                className="mt-3"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.inputEmail}
              />
              {formik.touched.inputEmail && formik.errors.inputEmail ? (
                <div className="form-error">{formik.errors.inputEmail}</div>
              ) : null}

              <Form.Control
                ref={contactMessage}
                as="textarea"
                type="text"
                id="inputMessage"
                name="inputMessage"
                rows="4"
                placeholder="Message..."
                className="mt-3"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.inputMessage}
              />
              {formik.touched.inputMessage && formik.errors.inputMessage ? (
                <div className="form-error mb-3">
                  {formik.errors.inputMessage}
                </div>
              ) : null}
            </Form.Group>

            <Button
              // onClick={clicked}
              variant="danger"
              type="submit"
              className="btn btn-block bg-orange-a text-white contact-btn mb-3"
            >
              Send
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
